module.exports = __webpack_public_path__ + "img/pic10.af1ddd37.png";